:host {
  // couldn't use cell-span and calcuate the with with css calc
  // since IE was calculating the width wrongly with certain viewport widths
  // so calculating it with sass and using the width directly
  --cell-width: 100%;

  max-width: 100%;
  width: var(--cell-width);
  flex-basis: var(--cell-width);
  flex-shrink: 0;
}

/* Align variants */

:host([align="left"]) {
  margin-right: auto;
}

:host([align="right"]) {
  margin-left: auto;
}

:host([align="middle"]) {
  margin-left: auto;
  margin-right: auto;
}

/* Align self variants */

:host([align-self="start"]) {
  align-self: flex-start;
}

:host([align-self="end"]) {
  align-self: flex-end;
}

:host([align-self="center"]) {
  align-self: center;
}

:host([align-self="baseline"]) {
  align-self: baseline;
}

:host([align-self="stretch"]) {
  align-self: stretch;
}

@mixin cellProps($breakpoint: null) {
  @for $i from 1 through $gridCells {
    @if $breakpoint {
      :host([span-#{$breakpoint}="#{$i}"]) {
        @include mq($from: $breakpoint) {
          --cell-width: #{calc(100% / ($gridCells / $i))};
        }
      }
    } @else {
      :host([span="#{$i}"]) {
        --cell-width: #{calc(100% / ($gridCells / $i))};
      }
    }
  }
}

@include cellProps();

@each $breakpoint, $size in $breakpoints {
  @include cellProps($breakpoint);
}

.stzh-cell {
  height: 100%;
  padding-left: calc(#{$gridGutter} / 2);
  padding-right: calc(#{$gridGutter} / 2);

  @include mq($from: small) {
    padding-left: calc(#{$gridGutterSmall} / 2);
    padding-right: calc(#{$gridGutterSmall} / 2);
  }

  @include mq($from: medium) {
    padding-left: calc(#{$gridGutterMedium} / 2);
    padding-right: calc(#{$gridGutterMedium} / 2);
  }

  @include mq($from: large) {
    padding-left: calc(#{$gridGutterLarge} / 2);
    padding-right: calc(#{$gridGutterLarge} / 2);
  }

  @include mq($from: ultra) {
    padding-left: calc(#{$gridGutterUltra} / 2);
    padding-right: calc(#{$gridGutterUltra} / 2);
  }
}
